<script setup lang="ts">
// Decorative directional arrow used after CTA labels and as scroll/bounce
// indicators. Renders as inline SVG (not a Unicode glyph) so `currentColor`
// reliably inherits the surrounding text-colour class with no font/OS
// variance - see GitHub issue #145.
withDefaults(
  defineProps<{
    direction?: 'right' | 'down'
  }>(),
  {
    direction: 'right',
  },
)

const paths: Record<'right' | 'down', string> = {
  right: 'M5 12h14M12 5l7 7-7 7',
  down: 'M12 5v14M5 12l7 7 7-7',
}
</script>

<template>
  <svg
    class="inline-block align-middle"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="paths[direction]" />
  </svg>
</template>
